/**
 *
 * Asynchronously loads the component for Mse004
 * Author: LocNt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
